// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import './TrailOrderHistory.css'
// import { Navigate, useNavigate } from "react-router-dom";
// import TrialCartItem from "../../components/TrialCartItem/TrialCartItem";
// import NoData from "../../components/NoData/NoData";
// import Loaderdots from "../../components/LoaderDots/Loaderdots";

// const TrailOrderHistory = () => {
//   const [trialCartData, setTrialCartData] = useState([]);
  
//   const navigate = useNavigate();
//     const [loading, setLoading] = useState(false); // Loader state
  

//   //razorpay
//   function loadScript(src) {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = src;
//       script.onload = () => {
//         resolve(true);
//       };
//       script.onerror = () => {
//         resolve(false);
//       };
//       document.body.appendChild(script);
//     });
//   }

//   useEffect(() => {
//     loadScript("https://checkout.razorpay.com/v1/checkout.js");
//   }, []);

 
    
    

  

//   const handlePlaceOrder = async (tryAndBuyCartId) => {
//      setLoading(true);
//     try {
     
//       const response = await fetch(
//         "https://riymay.com/api/v1/user/try/before/buy/place/order",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("userToken")}`,
//           },
//           body: JSON.stringify({ tryAndBuyCartId }),
//         }
//       );

//       const data = await response.json();
//       if (data.message == "Invalid token" || data.message == "Invalid or expired token") {
//         localStorage.removeItem("userToken");
//         navigate("/login");
//       }

//       if (!response.ok) {
//         toast.error(`❌ ${data.message || "Failed to place order"}`, {
//           position: "top-right",
//           autoClose: 5000, 
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           theme: "colored",
//         });
//                 throw new Error(data.message || "Failed to place order");
//       }

//       toast.error("Order placed successfully", {
//         position: "top-right",
//         autoClose: 5000, 
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         theme: "colored",
//       });
      
//       const options = {
//         key: "rzp_test_shS6viKWRoeKVm",
//         order_id: data.response.razorpayInfo.id,
//         handler: async function (response) {
//           try {
//             const validateResponse = await fetch(
//               "https://riymay.com/api/v1/user/try/before/buy/verify/payment",
//               {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "application/json",
//                   Authorization: `Bearer ${localStorage.getItem("userToken")}`,
//                 },
//                 body: JSON.stringify(response),
//               }
//             );

//             if (!validateResponse.ok) {
//               throw new Error(
//                 `Payment capture error: ${validateResponse.statusText}`
//               );
//             }

//             await validateResponse.json();
//             navigate("/home");
//           } catch (error) {
//             toast.error("❌ Payment validation failed. Please try again!", {
//               position: "top-right",
//               autoClose: 5000, // Closes after 5 seconds
//               hideProgressBar: false,
//               closeOnClick: true,
//               pauseOnHover: true,
//               draggable: true,
//               theme: "colored",
//             });
//                       }
//         },
//       };
//       if (!window.Razorpay) {
//         toast.error("❌ Razorpay SDK not loaded. Please refresh the page.", {
//           position: "top-right",
//           autoClose: 5000, // Closes after 5 seconds
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           theme: "colored",
//         });
        
//         return;
//       }

//       var rzp1 = new window.Razorpay(options);
//       rzp1.on("payment.failed", function (response) {
//         toast.error(`❌ Payment failed: ${response.error.description}`, {
//           position: "top-right",
//           autoClose: 5000, // Closes after 5 seconds
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           theme: "colored",
//         });
//               });

//       rzp1.on("payment.cancel", function (response) {
//         toast.error("Payment canceled by the user..", {
//           position: "top-right",
//           autoClose: 5000, // Closes after 5 seconds
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           theme: "colored",
//         });
        
//       });

//       rzp1.open();

//       // Optionally refetch orders or update the UI
//       setTrialCartData((prevData) =>
//         prevData.filter((cart) => cart._id !== tryAndBuyCartId)
//       );
//       navigate("/");
//     } catch (err) {
//       console.error(err);
//       toast.error("An error occurred while placing the order", {
//         position: "top-right",
//         autoClose: 5000, // Closes after 5 seconds
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         theme: "colored",
//       });
      
//     }
//     finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchUserOrders = async () => {
//       try {
//         const response = await fetch(
//           "https://riymay.com/api/v1/user/try/before/buy/cart",
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("userToken")}`,
//             },
//           }
//         );
//         const data = await response.json();
//         if (data.message == "Invalid token" || data.message == "Invalid or expired token") {
//           localStorage.removeItem("userToken");
//           Navigate("/login");
//         }
//         if (!response.ok) {
//           // toast.error("Failed to Fetch", {
//           //   position: "top-right",
//           //   autoClose: 5000, // Closes after 5 seconds
//           //   hideProgressBar: false,
//           //   closeOnClick: true,
//           //   pauseOnHover: true,
//           //   draggable: true,
//           //   theme: "colored",
//           // });
          
//           throw new Error("Failed to fetch orders");
//         }
//         setTrialCartData(data.userTryAndBuyCartData);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchUserOrders();
//   }, [navigate]);
//   if(loading) return <Loaderdots />

//   return (
//     <>
//       <div className="try-and-buy-cart-container">
//       <h3>Review Your Trial Cart</h3>
//       <p className="cart-section-delete-item-text">Your Trial Cart will vanish within 7 days</p>

     
//           {trialCartData && trialCartData.length == 0 ? (
//             <NoData />
//           ) : (
//             trialCartData.map((cartTrialData) => (
//               <div className="cart-section-1">
//                 {/* <p>{cartTrialData._id}</p> */}

//                 <div className="try-and-buy-cart-sub-container">
//                   {cartTrialData.trialItems.map((item) => {
//                     return (
//                       <div className="cart-item-new">
                       
//                         <TrialCartItem
//                           item={item}
//                           checked={true}
//                           tryAndBuyCartId={cartTrialData._id}
//                         />
//                       </div>
//                     );
//                   })}
//                   {cartTrialData.rejectedTrialItems.map((item) => {
//                     return (
//                       <div className="cart-item-new">
                       
//                         <TrialCartItem
//                           item={item}
//                           checked={false}
//                           tryAndBuyCartId={cartTrialData._id}
//                         />
//                       </div>
//                     );
//                   })}
//                 </div>
                
//                 <div className="shipping-address-container">
//                 <div> <p className="shipping-address">
//                     <strong>Shipping Addr:</strong>{" "}
//                     {cartTrialData.trialShippingAddress.street}
//                   </p></div>
                 
//                  <div>
//                  <button
//                     onClick={() => handleDeleteCart(cartTrialData._id)}
//                     className="place-order-del-button"
//                   >
//                     Delete trial cart 🗑️
//                   </button>
//                   <button
//                     onClick={() => handlePlaceOrder(cartTrialData._id)}
//                     className="place-order-button"
//                   >
//                     Place Order ↗️
//                   </button>
//                  </div>
                 
                  
//                 </div>

//               </div>
//             ))
//           )}
//       </div>
//     </>
//   );
// };

// export default TrailOrderHistory;


import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import './TrailOrderHistory.css';
import { Navigate, useNavigate } from "react-router-dom";
import TrialCartItem from "../../components/TrialCartItem/TrialCartItem";
import NoData from "../../components/NoData/NoData";
import Loaderdots from "../../components/LoaderDots/Loaderdots";

const TrailOrderHistory = () => {
  const [trialCartData, setTrialCartData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Loader state

  // Cashfree integration
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  useEffect(() => {
    loadScript("https://sdk.cashfree.com/js/v3/cashfree.js");
  }, []);
  const handleDeleteCart = async(trailcartId) => {
    setLoading(true); // Show loader while deleting item
    try {
      const response = await fetch(
        `https://riymay.com/api/v1/user/try/before/buy/cart/${trailcartId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setTrialCartData((prevData) => prevData.filter((cart) => cart._id !== trailcartId));
      if (data.success == true) {
        toast.success("🗑️ Cart item deleted successfully!", {
          position: "top-right",
          autoClose: 3000, // Closes after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          // className: "custom-toast",
          // bodyClassName: "custom-toast-body",
        });
       } else {
        toast.error(`❌ ${data.message}`, {
          position: "top-right",
          autoClose: 5000, // Closes after 5 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
                }
    } catch (error) {
      console.error("Failed to delete cart item");
    }
    finally{
      setLoading(false);
    }
  }

  const handlePlaceOrder = async (tryAndBuyCartId) => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://riymay.com/api/v1/user/try/before/buy/place/order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
          body: JSON.stringify({ tryAndBuyCartId }),
        }
      );

      const data = await response.json();
      if (data.message === "Invalid token" || data.message === "Invalid or expired token") {
        localStorage.removeItem("userToken");
        navigate("/login");
      }

      if (!response.ok) {
        toast.error(`❌ ${data.message || "Failed to place order"}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        throw new Error(data.message || "Failed to place order");
      }

      toast.success("Order placed successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });

      // Initialize Cashfree payment
      const cashfree = new window.Cashfree();
      const paymentOptions = {
        orderToken: data.response.cashfreeInfo.token, // Replace with the token received from your backend
        orderId: data.response.cashfreeInfo.orderId, // Replace with the order ID received from your backend
        onSuccess: async (paymentData) => {
          try {
            const validateResponse = await fetch(
              "https://riymay.com/api/v1/user/try/before/buy/verify/payment",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                },
                body: JSON.stringify(paymentData),
              }
            );

            if (!validateResponse.ok) {
              throw new Error(
                `Payment validation error: ${validateResponse.statusText}`
              );
            }

            await validateResponse.json();
            navigate("/home");
          } catch (error) {
            toast.error("❌ Payment validation failed. Please try again!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
          }
        },
        onFailure: (error) => {
          toast.error(`❌ Payment failed: ${error.reason}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        },
      };

      cashfree.init(paymentOptions);
      cashfree.open();

      // Optionally refetch orders or update the UI
      setTrialCartData((prevData) =>
        prevData.filter((cart) => cart._id !== tryAndBuyCartId)
      );
      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while placing the order", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const response = await fetch(
          "https://riymay.com/api/v1/user/try/before/buy/cart",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );
        const data = await response.json();
        if (data.message === "Invalid token" || data.message === "Invalid or expired token") {
          localStorage.removeItem("userToken");
          Navigate("/login");
        }
        if (!response.ok) {
          throw new Error("Failed to fetch orders");
        }
        setTrialCartData(data.userTryAndBuyCartData);
      } catch (err) {
        console.error(err);
      }
    };

    fetchUserOrders();
  }, [navigate]);

  if (loading) return <Loaderdots />;

  return (
    <>
      <div className="try-and-buy-cart-container">
        <h3 className="trail-page-title">Review Your Trial Cart</h3>
        <p className="cart-section-delete-item-text">
          Your Trial Cart will vanish within 7 days
        </p>

        {trialCartData && trialCartData.length === 0 ? (
          <NoData />
        ) : (
          trialCartData.map((cartTrialData) => (
            <div className="cart-section-1">
              <div className="try-and-buy-cart-sub-container">
                {cartTrialData.trialItems.map((item) => {
                  return (
                    <div className="cart-item-new">
                      <TrialCartItem
                        item={item}
                        checked={true}
                        tryAndBuyCartId={cartTrialData._id}
                      />
                    </div>
                  );
                })}
                {cartTrialData.rejectedTrialItems.map((item) => {
                  return (
                    <div className="cart-item-new">
                      <TrialCartItem
                        item={item}
                        checked={false}
                        tryAndBuyCartId={cartTrialData._id}
                      />
                    </div>
                  );
                })}
              </div>

              <div className="shipping-address-container">
                <div>
                  <p className="shipping-address">
                    <strong>Shipping Addr:</strong>{" "}
                    {cartTrialData.trialShippingAddress.street}
                  </p>
                </div>

                <div>
                  <button
                    onClick={() => handleDeleteCart(cartTrialData._id)}
                    className="place-order-del-button"
                  >
                    Delete trial cart 🗑️
                  </button>
                  <button
                    onClick={() => handlePlaceOrder(cartTrialData._id)}
                    className="place-order-button"
                  >
                    Place Order ↗️
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default TrailOrderHistory;
